import * as $ from "jquery";
import { Grid } from 'ag-grid-community';

export default class PromotionCodeReport {
    constructor() {
        this.componentSelector = "#promocodereport";
        this.grid = null;
        this.instance = this;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;
        $('#loader').hide();

        $('.js-download-excel').off().on('click', function () {
            instance.download(instance);
        });

        $('.js-download-details-excel').off().on('click', function () {
            instance.downloadDetails(instance);
        });

        $('.js-show-result').off().on('click', function () {
            instance.search(instance);
        });
    }

    search(instance) {
        $('#loader').show();
        $('#report').hide();
        var startDate = $('#startdate').val();
        var endDate = $('#enddate').val();

        axios({
            method: 'get',
            url: "/report/GetPromotionCodeReport",
            params: { startdate : startDate, enddate : endDate }
        }).then(function (response) {
            $('#loader').hide();
            $('#report').show();
            instance.render(instance, JSON.parse(response.data));
        }).catch(function (response) {
        });
    }

    currencyFormatter(params) {
        return new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.value);
    };

    renderDetailsGrid(details) {
        const colDefs = [
            { headerName: 'Marknad', field: 'MarketId', sortable: true, filter: true, resizable: true },
            { headerName: 'Kundnr', field: 'CustomerNumber', sortable: true, filter: true, resizable: true },
            { headerName: 'Ordernr', field: 'OrderNumber', sortable: true, filter: true, resizable: true },
            { headerName: 'Datum', field: 'UseTime', sortable: true, filter: true, resizable: true },
            { headerName: 'Ordervärde', field: 'OrderAmount', sortable: true, filter: true, resizable: true },
        ];

        if (!this.detailsGridOptions) {
            this.detailsGridOptions = {
                columnDefs: colDefs,
                rowData: details,
                defaultColDef: { sortable: true, filter: true, resizable: true },
                domLayout: 'normal',
                animateRows: true,
                pagination: true,
                paginationPageSize: 100,
            };

            const el = document.querySelector('#detailsGrid');
            new Grid(el, this.detailsGridOptions);
        } else {
            this.detailsGridOptions.api.setRowData(details);
        }
    }

    openDetailsModal(row) {

        $('#detailsModal')
            .data('campaignDbId', row.CampaignDbId);

        $('#detailsTitle').text(`Användningar: ${row.CampaignId} (${row.PromotionCode})`);
        $('#detailsModal').show();
        $('#detailsLoader').show();
        $('#detailsGrid').hide();

        const startDate = $('#startdate').val();
        const endDate = $('#enddate').val();

        axios({
            method: 'get',
            url: "/report/GetPromotionCodeDetails",
            params: {
                campaignId: row.CampaignDbId,
                startDate: startDate,
                endDate: endDate
            }
        }).then((response) => {
            const details = JSON.parse(response.data);

            $('#detailsLoader').hide();
            $('#detailsGrid').show();

            this.renderDetailsGrid(details);
        }).catch((err) => {
            $('#detailsLoader').text('Kunde inte ladda detaljer.');
        });
    }

    closeDetailsModal() {
        $('#detailsModal').hide();
    }

    render(instance, data) {

        if (instance.grid == null) {
            instance.grid = {
                columnDefs: [
                    { headerName: 'ID', field: 'CampaignDbId', hide: true },
                    { headerName: 'Kampanj-ID', field: 'CampaignId', resizable: true   },
                    { headerName: 'Rabattkod', field: 'PromotionCode', resizable: true   },
                    { headerName: 'Antal användningar', field: 'UsageCount', resizable: true   },
                    { headerName: 'Antal unika kunder', field: 'UniqueCustomers', resizable: true },
                    { headerName: 'Totalt ordervärde', field: 'TotalOrderValue', resizable: true },
                ],
                rowData: data,
                defaultColDef: {
                    sortable: true, filter: true, comparator: function (a, b) {
                        // Case-insensitive för strängar
                        if (typeof a === 'string' || typeof b === 'string') {
                            var aa = (a == null ? '' : a).toString().toLowerCase();
                            var bb = (b == null ? '' : b).toString().toLowerCase();
                            return aa.localeCompare(bb);
                        }

                        // fallback för nummer, datum osv
                        if (a == null && b == null) return 0;
                        if (a == null) return -1;
                        if (b == null) return 1;
                        return a > b ? 1 : (a < b ? -1 : 0);
                    }
                },
                domLayout: 'autoHeight',
                onRowClicked: function (event) {
                    instance.openDetailsModal(event.data);
                }
            };

            var eGridDiv = document.querySelector('#report');
            new Grid(eGridDiv, instance.grid);

            $('#detailsCloseBtn').on('click', function () {
                instance.closeDetailsModal();
            });

            $('#detailsModal').on('click', function (e) {
                if (e.target.id === 'detailsModal') instance.closeDetailsModal();
            });
        }
        else {
            instance.grid.api.setRowData(data);
        }
    }

    download(instance) {
        var startDate = $('#startdate').val();
        var endDate = $('#enddate').val();

        var uri = "/report/GetPromoCodeReportAsExcel?startDate=" + startDate + "&endDate=" + endDate;

        var date = new Date();
        var cache = date.getUTCFullYear() + date.getUTCMonth() + date.getUTCDate() + date.getUTCHours() + date.getUTCMinutes() + date.getUTCSeconds() + date.getUTCMilliseconds();
        var fileName = "rabattkoder-" + date.toISOString().split('T')[0] + ".xlsx";

        let query = $('#query').val();

        var x = new XMLHttpRequest();
        x.open("POST", uri, true);
        x.responseType = "blob";
        x.onload = function (e) { download(e.target.response, fileName, "application/vnd.ms-excel"); };

        //var params = JSON.stringify({ sysIds: query });
        //x.setRequestHeader("Content-length", params.length);
        x.send();

        var data = new FormData();
        //data.append('sysIds', query);
        x.send();

        if (typeof (callback) === 'function')
            callback();
    }

    downloadDetails(instance) {
        var $modal = $('#detailsModal');

        var campaignDbId = $modal.data('campaignDbId');

        var startDate = $('#startdate').val();
        var endDate = $('#enddate').val();

        var uri = "/report/GetPromoCodeDetailsReportAsExcel?campaignId= " + campaignDbId  + "&startDate=" + startDate + "&endDate=" + endDate;

        var date = new Date();
        var cache = date.getUTCFullYear() + date.getUTCMonth() + date.getUTCDate() + date.getUTCHours() + date.getUTCMinutes() + date.getUTCSeconds() + date.getUTCMilliseconds();
        var fileName = "rabattkoder-" + date.toISOString().split('T')[0] + ".xlsx";

        let query = $('#query').val();

        var x = new XMLHttpRequest();
        x.open("POST", uri, true);
        x.responseType = "blob";
        x.onload = function (e) { download(e.target.response, fileName, "application/vnd.ms-excel"); };

        //var params = JSON.stringify({ sysIds: query });
        //x.setRequestHeader("Content-length", params.length);
        x.send();

        var data = new FormData();
        //data.append('sysIds', query);
        x.send();

        if (typeof (callback) === 'function')
            callback();
    }
}